// Note: rollup/index.ts imports ./effects which registers the rollup-config-menu component (E018-S008-T009)
// Initialize column menu hooks (registers Relation/Rollup config menus via window global)
// Located in streamlain/ folder for license separation
import '../../streamlain/database/column-menu-hooks';

import type { PropertyMetaConfig } from '@blocksuite/affine/blocks/database';

import { createdByPropertyConfig } from './created-by/view';
import { docReferencePropertyConfig } from './doc-reference/view';
import { filePropertyConfig } from './file/view';
import { memberPropertyConfig } from './member/view';
import { relationPropertyConfig } from './relation';
// Note: relation/index.ts imports ./effects which registers the relation-config-menu component
import { rollupPropertyConfig } from './rollup';
import { updatedByPropertyConfig } from './updated-by/view';

export const propertiesPresets: PropertyMetaConfig<string, any, any, any>[] = [
  filePropertyConfig,
  memberPropertyConfig,
  createdByPropertyConfig,
  updatedByPropertyConfig,
  relationPropertyConfig,
  rollupPropertyConfig,
  // sl-9qm.22: Doc-reference column type
  docReferencePropertyConfig,
];
